import { withContext } from '@tools/wr-catalog-base'
import ProductBody from './ProductBody'

export default withContext(ProductBody, {
  mapProps: (context) => ({
    openModal: context.actions.openModal,
    closeModal: context.actions.closeModal,
  }),
})
